import { render, staticRenderFns } from "./pop-stat.vue?vue&type=template&id=6da3c385&scoped=true&"
import script from "./pop-stat.vue?vue&type=script&lang=js&"
export * from "./pop-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3c385",
  null
  
)

export default component.exports